import styled from "@emotion/styled";
import { MediaCard } from "@kaltura/mediaspace-shared-media-card";
import { KalturaESearchEntryResult } from "kaltura-typescript-client/api/types/KalturaESearchEntryResult";
import { SrOnly } from "@kaltura/mediaspace-shared-ui";

export interface EntrySearchResultsProps {
    entries: KalturaESearchEntryResult[];
    onMore?: (searchResult: KalturaESearchEntryResult) => void;
    isTextSearch?: boolean;
    isWideLayout: boolean;
    activeEntry?: string;
    title?: string;
}

const StyledUl = styled("ul")({
    padding: 0,
    margin: 0,
});

const StyledEntryResult = styled("li")(({ theme }) => ({
    display: "block",
    marginBottom: theme.spacing(2),
}));

const H2SrOnly = SrOnly("h2");

/**
 * Global Search Entry search results
 */
export function EntrySearchResults(props: EntrySearchResultsProps) {
    const { entries, activeEntry, onMore, isTextSearch, isWideLayout, title } = props;

    const mode = isTextSearch ? "search" : "list";

    return (
        <>
            {title && <H2SrOnly>{title}</H2SrOnly>}
            <StyledUl>
                {entries.map((entry) => (
                    <StyledEntryResult key={entry.object.id} className="kms-ds-global-search-result-item">
                        <MediaCard
                            data={entry}
                            mode={mode}
                            onMore={onMore}
                            active={entry.object.id === activeEntry && !isWideLayout}
                        />
                    </StyledEntryResult>
                ))}
            </StyledUl>
        </>
    );
}
